import React, { useState } from "react";
import * as RB from 'react-bootstrap';
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { NavLink, useHistory } from "react-router-dom";
import { logoutUser } from "../../redux/actions/auth";
import axiosAPI from "../api/axiosApi";

import { faChartBar, faDatabase, faDesktop, faPrint, faSignOutAlt, faUser, faCertificate} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { authFetch } from "../api/authenticationApi2";
import {LICENSE_URL} from "../pages/params";

const Header = ({ accessToken, logoutUser }) => {
    // const [username, setUsername] = useState("");

    const history = useHistory();
    var is_admin = false;
    var tokenParts = null;

    var username = '1111';    

    if (accessToken) {
        tokenParts = JSON.parse(atob(accessToken.split(".")[1]));
        is_admin = tokenParts.is_staff || tokenParts.is_superuser;
        username = tokenParts.username;
        // setUsername(tokenParts.username);

    }

        const handleLogout = async () => {
        await logoutUser();
        history.push("login/");
    };

    const go2admin = () => {
        var win = window.open('about:blank');
        var url_ = process.env.API_URL + '../admin/';
        win.location.href = url_;
        // Эксперименты с попыткой передать JWT-авторизацию внутрь сессионной авторизации справочников.
        // axiosAPI.get('../admin/', null, {withCredentials: true})
        // .then(function (response) {
        //     //win.history.push(url_);
        //     // win.history.pushState({"html":response.data,"pageTitle":"admin"}, "", url_);
        //     win.document.write(response.data);
        // })
        // .catch(function (error) {
        //   // Error callback
        // });
    }

    const [licenseStatus, setLicenseStatus] = useState("");
    const [licenseIconBeat, setLicenseIconBeat] = useState(false);
    const [licenseMsg, setLicenseMsg] = useState('');

    const LicenseInfo = async ({setLicenseStatus, setLicenseIconBeat, setLicenseMsg}) => {
        const response = await authFetch(LICENSE_URL, {
            method: "GET",
            headers: { "Content-Type": "application/json" }
        });
        if (response.ok) {
            const data = await response.json();
            if (!data.certificate_validation) {
                setLicenseStatus("text-warning");
                setLicenseMsg(data.message);
            } else {
                if (data.expires_in < 30) {
                    setLicenseIconBeat(true);
                    setLicenseStatus("text-danger");
                } else if (data.expires_in < 60) {
                    setLicenseStatus("text-danger");
                } else if (data.expires_in < 90) {
                    setLicenseStatus("text-warning");
                } else {
                    setLicenseStatus("text-success");
                }
                setLicenseMsg(
                    `истекает через ${data.expires_in} дней
                    активно ${data.active_license} из ${data.legal_license} лицензий`);
            } 
        } else if (response.status == 515) {
            const data = await response.json();
            setLicenseIconBeat(true);
            setLicenseStatus("text-danger");
            setLicenseMsg(data.detail.message);
        }
    }
    LicenseInfo({setLicenseStatus, setLicenseIconBeat, setLicenseMsg});

    const licenseTooltip = (
        <RB.Tooltip id="license-tooltip">
            <p className="text-sm-left">
                {licenseMsg}
            </p>
        </RB.Tooltip>
    );

    return (
        <RB.Navbar bg="light" expand="lg">
            {/*
            <RB.Navbar.Brand href="#home">
                <RB.Image src="dm-favicon.svg" height="32" width="auto" />
            </RB.Navbar.Brand>
            */}
            <RB.Navbar.Toggle aria-controls="basic-navbar-nav" />
            <RB.Navbar.Collapse id="basic-navbar-nav" >
                {accessToken ? (<RB.Nav className="mr-auto">
                    <RB.Nav.Link href="/investigatescreen">
                        <FontAwesomeIcon icon={faDesktop} fixedWidth />Screen-Cam
                    </RB.Nav.Link>
                    <RB.Nav.Link href="/investigateprint">
                        <FontAwesomeIcon icon={faPrint} fixedWidth />Print-Cam/Scan
                    </RB.Nav.Link>
                    {
                        is_admin ? (<>
                            <RB.Nav.Link href="/dashboard" >
                                <FontAwesomeIcon icon={faChartBar} fixedWidth />Статистика
                            </RB.Nav.Link>
                            {
                            /* Пока оно работает неправильно, лучше отключить
                             *
                             * <RB.Nav.Link href="/monitoring-pc" > Мониторинг PC </RB.Nav.Link>
                             */
                            }
                            <RB.Nav.Link href={process.env.API_URL + '../admin/'} target="_blank" >
                                <FontAwesomeIcon icon={faDatabase} fixedWidth />ЦСИ
                            </RB.Nav.Link>
                        </>) : (<> </>)
                    } </RB.Nav>
                ) : (<> </>)}

                <RB.OverlayTrigger placement="bottom" overlay={licenseTooltip}>
                    <RB.Nav className="mr-sm-2">
                        <RB.Navbar.Text>
                            <FontAwesomeIcon 
                                icon={faCertificate} 
                                beat={licenseIconBeat} 
                                className={licenseStatus} 
                                fixedWidth />Лицензия
                        </RB.Navbar.Text>
                    </RB.Nav>
                </RB.OverlayTrigger>

                <RB.Nav className="mr-sm-2" > {
                    accessToken ? (<>
                        <RB.Navbar.Text>
                            <FontAwesomeIcon icon={faUser} fixedWidth />{username}
                        </RB.Navbar.Text>
                        <RB.Nav.Link href="/logout" onClick={handleLogout}>
                            <FontAwesomeIcon icon={faSignOutAlt} fixedWidth />Выйти
                        </RB.Nav.Link>
                    </>) : (<>
                        {/* <RB.Nav.Link href="/login" > Вход </RB.Nav.Link>   */}
                        </>
                    )
                } </RB.Nav> </RB.Navbar.Collapse> </RB.Navbar>

    );
};

Header.propTypes = {
    accessToken: PropTypes.string,
    logoutUser: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
    return {
        accessToken: state.auth,
    };
}

const mapDispatchToProps = {
    logoutUser,
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
